import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/logo.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "header-logo",
  id: "logo"
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  class: "col-md-8 col-sm-10 col-xs-12 q-pa-md",
  id: "pageComponentContainer"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Powered by RightCrowd", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  class: "text-h6",
  id: "dialogHeaderTitle"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_q_footer = _resolveComponent("q-footer")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_layout, {
      view: "hHh lpR fFf",
      id: "pageLayout"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_header, {
          bordered: "",
          class: "text-primary header",
          id: "pageHeaderContainer"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, {
              class: "q-px-md q-mx-sm",
              id: "pageHeaderToolbar"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["header-logo-container", {'disable-events': _ctx.portal.disableHomeButtonClick }]),
                  id: "logoContainer",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
                }, _hoisted_2, 2),
                _createVNode(_component_q_toolbar_title, {
                  class: _normalizeClass([{'disable-events': _ctx.portal.disableHomeButtonClick }, "header-title"]),
                  id: "headerTitle"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      id: "headerTitleContent",
                      class: "header-title-content",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
                    }, _toDisplayString(_ctx.$t("portal_visitorPortal")), 1)
                  ]),
                  _: 1
                }, 8, ["class"]),
                (_ctx.locales.length > 1)
                  ? (_openBlock(), _createBlock(_component_q_select, {
                      key: 0,
                      modelValue: _ctx.selectedLocale,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedLocale) = $event)),
                      options: _ctx.locales.map(l => ({ label: l.toUpperCase(), value: l })),
                      "display-value": _ctx.selectedLocale?.toUpperCase(),
                      id: "languageSelect",
                      "aria-label": "Select language",
                      dense: "",
                      outlined: "",
                      "emit-value": "",
                      "map-options": "",
                      "options-dense": "",
                      behavior: "menu",
                      "popup-content-class": "language-select-popup"
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "language",
                          size: "18px",
                          color: "primary",
                          "aria-hidden": "true"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options", "display-value"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_btn, {
                  onClick: _ctx.$q.dark.toggle,
                  flat: "",
                  round: "",
                  dense: "",
                  color: _ctx.$q.dark.isActive ? 'white' : 'black',
                  icon: _ctx.$q.dark.isActive ? 'light_mode' : 'dark_mode',
                  id: "darkMode"
                }, null, 8, ["onClick", "color", "icon"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.portal.isAppReady)
          ? (_openBlock(), _createBlock(_component_q_page_container, {
              key: 0,
              class: _normalizeClass(_ctx.portal.navPageConfig[_ctx.portal.currentNavIndex].pageClass)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_page, {
                  class: _normalizeClass(["flex q-layout-padding flex justify-center items-start row", { 'content-center': _ctx.portal.currentNavIndex === 1 }]),
                  id: "pageContentContainer"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.portal.navPageConfig[_ctx.portal.currentNavIndex].component), _normalizeProps(_guardReactiveProps(_ctx.portal.navPageConfig[_ctx.portal.currentNavIndex])), null, 16))
                    ])
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_q_footer, {
          bordered: "",
          class: "text-primary q-pa-sm footer",
          id: "pageFooter"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, { id: "pageFooterToolbar" }, {
              default: _withCtx(() => [
                _createVNode(_component_NavBar, {
                  onNext: _ctx.next,
                  onBack: _ctx.back,
                  onSkip: _ctx.skip
                }, null, 8, ["onNext", "onBack", "onSkip"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_q_footer, {
          bordered: "",
          class: "text-primary q-pa-sm footer",
          id: "poweredByRcFooter"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              id: "poweredByRcContent",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToRightCrowd && _ctx.goToRightCrowd(...args)))
            }, _hoisted_5)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.portal.shouldOpenDialog,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.portal.shouldOpenDialog) = $event)),
      id: "dialogBox"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { id: "card" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, {
              class: "bg-negative text-white",
              id: "dialogHeader"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_q_icon, {
                    name: "error_outline",
                    size: "25px",
                    id: "dialogHeaderIcon"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.portal.dialogTitle)), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { id: "dialogContent" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(_ctx.portal.dialogMsg)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, {
              align: "right",
              id: "dialogActionsContainer"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: _ctx.$t('portal_okBtn'),
                  color: "primary",
                  id: "dialogActionButton"
                }, null, 8, ["label"]), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}